"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantHasEstimatedPrices = void 0;
const getOrderLineEstimatedCheck_1 = require("./getOrderLineEstimatedCheck");
const variantHasEstimatedPrices = (variant) => {
    if (!variant)
        return false;
    if (!variant.order_lines)
        return false;
    return variant.order_lines.some((line) => (0, getOrderLineEstimatedCheck_1.getOrderLineEstimatedCheck)(line));
};
exports.variantHasEstimatedPrices = variantHasEstimatedPrices;
